import React from "react";

export const ConeIcon = ({ nameOfClass }) => {
    return <svg className={nameOfClass} viewBox="0 0 31 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 24L16 2L29 24H2Z" strokeWidth="4" strokeLinejoin="round" />
    </svg>;
};
